module.exports = __webpack_public_path__ + "img/VK(blue).2b3275fb.svg";